<template>
  <div>
    <slot name="activator"></slot>

    <v-dialog v-model="dialog" persistent fullscreen :retain-focus="false" scrollable>
      <v-card>
        <div style="height: 55px">
          <v-toolbar dark color="#042333">
            <v-btn icon dark @click="fecharDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title>Status da exportação Protheus</v-toolbar-title>
          </v-toolbar>
        </div>

        <v-divider />

        <v-card-text class="px-4 mt-5">
          <template v-if="error && error.errorCode">
            <p class="error--text mb-n1">{{ error.errorMessage }}</p>
          </template>

          <div v-else class="d-flex">
            <v-col cols="4" class="pa-0">
              <p class="subtitle-2 ma-0 py-1">Pedidos em Aberto</p>
              <template v-if="statusExportacao.abertos">
                <table class="w-220">
                  <tr>
                    <th class="text-left">N° Pedido</th>
                    <th class="text-left">Filial Origem</th>
                  </tr>
                  <tr v-for="(item, i) in statusExportacao.abertos" :key="`${i}_`">
                    <td>{{ item.pedido }}</td>
                    <td>{{ item.origem }}</td>
                  </tr>
                </table>
              </template>
              <span v-else class="caption color-gray">Nenhum</span>
            </v-col>

            <v-col cols="4" class="pa-0">
              <p class="subtitle-2 ma-0 py-1">Pedidos Faturados</p>

              <template v-if="statusExportacao.faturados">
                <table class="w-220">
                  <tr>
                    <th class="text-left">N° Pedido</th>
                    <th class="text-left">Filial Origem</th>
                  </tr>
                  <tr v-for="(item, i) in statusExportacao.faturados" :key="`${i}__`">
                    <td>{{ item.pedido }}</td>
                    <td>{{ item.origem }}</td>
                  </tr>
                </table>
              </template>
              <span v-else class="caption color-gray">Nenhum</span>
            </v-col>

            <v-col cols="4" class="pa-0">
              <p class="subtitle-2 ma-0 py-1">Pedidos não Encontrados</p>

              <template v-if="statusExportacao.nao_encontrados">
                <table class="w-220">
                  <tr>
                    <th class="text-left">N° Pedido</th>
                    <th class="text-left">Filial Origem</th>
                  </tr>
                  <tr v-for="(item, i) in statusExportacao.nao_encontrados" :key="`${i}___`">
                    <td>{{ item.pedido }}</td>
                    <td>{{ item.origem }}</td>
                  </tr>
                </table>
              </template>
              <span v-else class="caption color-gray">Nenhum</span>
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProtheusAPI from "../../../../api/drp/protheus";

export default {
  name: "DialogStatusExportacaoProtheus",
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: false
    },
    showActivator: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: {},
    statusExportacao: {}
  }),
  watch: {
    dialog () {
      if (this.dialog) {
        this.buscarStatusExportacao()
      }
    }
  },
  methods: {
    buscarStatusExportacao () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        id_pedido: this.item.idpedido
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        ProtheusAPI.getStatusExportacaoProtheus(headers, params)
          .then((response) => {
            const {token, resultado, error} = response.data;
            localStorage.setItem("token", token);
            this.statusExportacao = resultado
            this.error = error
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    fecharDialog () {
      this.error = {}
      this.statusExportacao = {}
      this.$emit('change-dialog', false)
      this.$emit('atualizar-pedidos')
    }
  }
}
</script>

<style scoped>
.color-gray {
  color: #888888;
}
.w-220 {
  width: 220px;
}
</style>
